<template>
  <v-row class=" d-flex flex-row flex-wrap" justify="center">
    <!-- <v-spacer></v-spacer> -->

    <v-col cols="12" sm="4" md="3" lg="2">
      <v-select
        id="categories"
        :items="categories"
        item-value="value"
        item-text="text"
        solo
        dense
        v-model="searchData.searchCategory"
        placeholder="Search Category"
      ></v-select>
    </v-col>
    <v-col sm="7" md="5" v-if="!searchData.searchCategory"></v-col>
    <v-col
      v-if="this.searchData.searchCategory == 'PaymentRequestId'"
      cols="10"
      sm="4"
    >
      <b-form-input
        v-model="searchData.paymentRequestId"
        type="text"
        placeholder="Customer Payment Request ID"
      ></b-form-input>
    </v-col>
    <v-col
      v-if="
        searchData.searchCategory == 'SendDate' ||
          searchData.searchCategory == 'CreatedDate'
      "
      cols="6"
      sm="3"
      md="2"
    >
      <label for="startDate" class="font-weight-bold">Start Date</label>
      <br />
      <input id="startDate" type="date" v-model="searchData.startDate" />
    </v-col>
    <v-col
      v-if="
        searchData.searchCategory == 'SendDate' ||
          searchData.searchCategory == 'CreatedDate'
      "
      cols="6"
      sm="3"
      md="2"
    >
      <label for="endDate" class="font-weight-bold">End Date</label>
      <br />
      <input id="endDate" type="date" v-model="searchData.endDate" />
      <br />
      <b
        class="red--text font-italic"
        v-if="
          !isDateValidated &&
            this.searchData.endDate &&
            this.searchData.startDate
        "
        >End Date Can't Be Before Start Date</b
      >
    </v-col>
    <v-col
      v-if="
        this.searchData.searchCategory == 'PaymentRequestId' ||
          this.searchData.searchCategory == 'SendDate' ||
          this.searchData.searchCategory == 'CreatedDate'
      "
      cols="2"
      sm="1"
    >
      <button
        :disabled="isButtonDisabled"
        type="button"
        class=" d-flex justify-center advanced-srch-btn"
        :class="isButtonDisabled ? 'btn btn-secondary' : 'btn btn-success'"
        @click="searchDatabase"
      >
        GO
      </button>
    </v-col>
  </v-row>
</template>

<style scoped>
.advanced-srch-btn {
  background-color: #6a63eb;
  color: #fff;
}
</style>

<script>
export default {
  data() {
    return {
      categories: [
        { text: "Payment Request Id", value: "PaymentRequestId" },
        { text: "Created Date", value: "CreatedDate" },
        { text: "Send Date", value: "SendDate" }
      ],
      searchData: {
        searchCategory: null,
        paymentRequestId: null,
        startDate: null,
        endDate: null
      }
    };
  },
  computed: {
    isDateValidated() {
      return (
        this.searchData.endDate >= this.searchData.startDate &&
        this.searchData.endDate &&
        this.searchData.startDate
      );
    },
    isButtonDisabled() {
      if (
        this.searchData.searchCategory == "PaymentRequestId" &&
        this.searchData.paymentRequestId
      )
        return false;

      if (this.isDateValidated) return false;

      return true;
    }
  },
  methods: {
    searchDatabase() {
      return this.$emit("retrievePaymentRequest", this.searchData);
    }
  }
};
</script>
